<template>
  <div class="">
    <div class="box-item">
      <div class="box-item--label is-required">起运城市</div>
      <div class="box-item--cotnent">
        <el-select v-model="cityRegionHeaderItem.cityList"
                   @change="changeCityList"
                   value-key="id"
                   multiple
                   clearable
                   filterable
                   size="small"
                   class="edit-form__input"
                   placeholder="请选择">
          <el-option
            v-for="(item, index) in cityList"
            :key="item.id"
            :label="item.cityName"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
    <template v-if="!(cityRegionHeaderItem.cityList && cityRegionHeaderItem.cityList.length)">
      <el-alert type="error" title="请先选择【起运城市】" />
    </template>
    <template v-else-if="!(goodsTypeList && goodsTypeList.length)">
      <el-alert type="error" title="请先在'基本信息'栏选择【可走货物类型】" />
    </template>
    <template v-else>
      <!--<br/>-->
      <div class="box-item">
        <!--      <div class="box-item&#45;&#45;label is-required"></div>-->
        <div class="box-item--cotnent">
          <el-checkbox
            v-model="cityRegionHeaderItem.isSupportMultiGoodsTypePrice"
            @input="changeMultiGoodsTypePrice"
            :true-label="1"
            :false-label="0"
            size="small">是否支持多产品分类报价</el-checkbox>
        </div>
      </div>
      <br/>
      <div class="box-item">
        <div class="box-item--label is-required">分区类型</div>
        <div class="box-item--cotnent">
          <el-select :value="regionType"
                     size="small"
                     disabled
                     class="edit-form__input"
                     placeholder="请选择">
            <el-option
              v-for="(item, index) in regionTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <el-link type="primary"
               @click="addRegionItem"
               :disabled="!canSelectSubareaTotalList.length"
               v-if="visibleAddedBtn"
               style="margin-top: 6px;">
        <el-icon class="el-icon-circle-plus-outline"></el-icon>
        增加分区
      </el-link>
      <br/>
      <template v-for="(item,index) in list">
        <div class="box-space-border"></div>
        <div class="box-item FormWrap">
          <div class="box-item--label is-required">分区名称</div>
          <div class="box-item--cotnent">
            <el-input v-model="item.regionName"
                      size="small"
                      class="edit-form__input"
                      placeholder="请输入"></el-input>
            <el-tag class="index" size="mini">{{index+1}}</el-tag>
          </div>
        </div>
        <el-link
          type="danger"
          @click="removeRegionItem(index)"
          v-if="list.length > 1"
          style="margin-top: 6px;"
          :key="index">
          <el-icon class="el-icon-delete"></el-icon>
          移除</el-link>
        <br/>
        <div class="box-item">
          <div class="box-item--label is-required">分区信息</div>
          <div class="box-item--cotnent">
            <el-select v-model="item.regionSelectValue"
                       class="edit-form__input"
                       size="small"
                       multiple
                       filterable
                       placeholder="请选择">
              <el-option
                v-for="item in canSelectSubareaList[index]"
                :key="item.warehouseId"
                :label="item.namec"
                :value="item.warehouseId">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="box-item ">
          <div class="box-item--label is-required">是否支持单询</div>
          <div class="box-item--cotnent">
            <el-radio-group
              v-model="item.isNeedInquiry"
              @input="value=>changeIsNeedInquiry(value,item,index)"
              :disabled="item.exemptionType === 2"
              size="small"
            >
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-for="(priceDetailItem,priceDetailIndex) in item.priceDetailList">
          <div class="box-item">
            <div class="box-item--label is-required">可走货物类型</div>
            <div class="box-item--cotnent">
              <el-select v-model="priceDetailItem.goodsTypeList"
                         value-key="id"
                         multiple
                         filterable
                         class="edit-form__input"
                         size="small"
                         placeholder="请选择">
                <el-option
                  v-for="item in goodsTypeList"
                  :key="item.id"
                  :label="item.goodsTypeName"
                  :value="item">
                </el-option>
              </el-select>
              <!--<el-tag class="index" size="mini">{{priceDetailIndex+1}}</el-tag>-->
            </div>
          </div>
          <template v-if="isSupportMultiChannel">
            <div class="box-item ">
              <div class="box-item--label is-required" style="width: 80px;">专线api对接渠道代码</div>
              <div class="box-item--cotnent">
                <el-input v-model="priceDetailItem.channelCode"
                          size="small"
                          style="width: 140px;"
                          placeholder="请输入"></el-input>
              </div>
            </div>
          </template>
          <template v-if="cityRegionHeaderItem.isSupportMultiGoodsTypePrice">
            <el-link type="primary"
                     @click="addGoodsTypeRow(item,index)"
                     v-if="priceDetailIndex === 0"
                     style="margin-top: 6px;">
              <el-icon class="el-icon-plus"></el-icon>
              增加可走货物类型
            </el-link>
            <el-link type="danger"
                     @click="removeGoodsTypeRow(item,index)"
                     v-else
                     style="margin-top: 6px;">
              <el-icon class="el-icon-remove"></el-icon>
              移除
            </el-link>
          </template>
        </div>
        <br/>
      </template>

      <div class="box-item" v-if="canSelectSubareaTotalList.length">
        <div class="box-item--label"></div>
        <div class="box-item--cotnent">
          未选：
          <span
            class="color-danger"
            v-for="(item,index) in canSelectSubareaTotalList"
            :key="index">
          {{item.namec}}{{index < canSelectSubareaTotalList.length - 1 ? '、':''}}
        </span>
        </div>
      </div>
      <br/>
    </template>
  </div>
</template>

<script>
import {rulesNotEmpty} from "@/assets/js/formRules";
import {
  baseDataPriceDetailItem, baseDataPriceDetailPriceItem,
  baseDataRegionHeaderItem
} from "@/components/QuotationManagement/components-productQuotation/productQuotation";
import {isArray, isObject} from "my-tools-kit";

let regionTypeArray = [
  {label:'邮编',value:1},
  {label:'国家',value:2},
  {label:'城市',value:3},
  {label:'仓库编码',value:4},
  { label: '邮编分区', value: 5 },
];
let timeTypeArray = [
  {label:'工作日',value:1},
  {label:'自然日',value:2},
];
export default {
  name: "cityRegionNameAndSelect3",
  props:{
    regionType:[String,Number],
    cityRegionHeaderItem:{// 城市维度分区item
      type:Object,
      default:()=>({}),
    },
    list:{//分区列表
      type:Array,
      default:()=>[],
    },
    tableHeadList:{ //表头列表(价格区间)
      type:Array,
      default:()=>[],
    },
    subareaList:{//目的地列表
      type:Array,
      default:()=>[],
    },
    chargeType:[String,Number],// 计费方式 通过 "物流产品详情"或"报价详情"接口获取
    visibleAddedBtn:{//展示新增分区按钮
      type:Boolean,
      default:true,
    },
    isSegment:Boolean,//是否是分段报价
    type:{ // 分段类型 1：全包(头程) 2:派送
      type:Number,
      default:1,
    },
    isSupportMultiChannel:Boolean,//是否多渠道

    cityList:{//供选择的起运城市列表
      type:Array,
      default:[],
    },
    goodsTypeList:{//供选择的货物类型列表
      type:Array,
      default:[],
    },
  },
  data(){
    return {
      /* 表单校验 */
      formRules: {
        no: [{trigger: 'blur', required: false}],
        require: [rulesNotEmpty()],
      },
      // 分区类型
      regionTypeList:regionTypeArray,
    }
  },
  computed:{
    /**
     * 已经选中的列表 [String|number]
     * */
    alreadySelectSubareaList(){
      let alreadySelect = [];
      this.list.forEach(res=>alreadySelect.push(...(res.regionSelectValue || [])));
      return alreadySelect;
    },
    /**
     * 可选分区列表 [Object]
     * */
    canSelectSubareaTotalList(){
      return this.subareaList.filter(res=>!this.alreadySelectSubareaList.includes(res.warehouseId));
    },
    /**
     * 对应分区可选的列表
     */
    canSelectSubareaList(){
      let valueList = this.canSelectSubareaTotalList.map(res=>res.warehouseId);
      return this.list.map(res=>{
        return this.subareaList.filter(item=>{
          let alreadySelectValue = res.regionSelectValue || [];
          return alreadySelectValue.includes(item.warehouseId) || valueList.includes(item.warehouseId);
        });
      })
    },
    /**
     * 按分区维度统计分区下已选择的 可走货物类型
     */
    regionAlreadySelectGoodsTypeList(){
      return this.list.map(regionItem=>{
        let arr = [];
        regionItem.priceDetailList.forEach(item => arr.push(...item.goodsTypeList));
        return arr;
      });
    }
  },
  methods:{
    /**
     * 新增分区
     */
    addRegionItem(){
      this.list.push(this.newRegionItem());
    },
    newRegionItem(){
      let data = baseDataRegionHeaderItem();
      let tableHeadList = this.tableHeadList||[];
      let firstItem = tableHeadList[0]||{};
      Object.assign(data,{
        regionType:this.regionType,//分区类型
        type:this.type || 1,//分段类型 1：全包(头程) 2:派送
        dispatchId:firstItem.dispatchId, //关联派送区间id
        chargeType:this.chargeType,//计费方式: CBM:体积 KG:重量
      })
      let goodsTypeList = [];
      let priceList = tableHeadList.map(res=>{
        if(!(res instanceof Object)) res = {};
        return Object.assign(baseDataPriceDetailPriceItem(),{
          chargeSectionDetailId:res.chargeSectionDetailId,// 分区区间id
          sectionStartNum:res.start,// 区间开始值
          sectionEndNum:res.end,// 区间结束值
        })
      });
      let priceDetailItem = Object.assign(baseDataPriceDetailItem(),{
        goodsTypeList,
        priceList,
      })
      data.priceDetailList.push(priceDetailItem);
      return data;
    },
    /**
     * 移除 分区item
     */
    removeRegionItem(index=1){
      this.list.splice(index,1);
    },
    /**
     * 改变值：是否支持单询
     */
    changeIsNeedInquiry(value,item,index){
      if(value){
        if(isArray(item.priceDetailList)) item.priceDetailList.forEach(item=> item.price = 0);
      }else{
        if(isArray(item.priceDetailList)) item.priceDetailList.forEach(item=> item.price = "");
      }
      // if(value && isArray(item.priceDetailList) && item.priceDetailList.length){
      //   item.colspan = item.priceDetailList.length;
      // }else {
      //   item.colspan = 1;
      // }
    },
    /**
     * 改变 是否支持多产品分类报价
     */
    changeMultiGoodsTypePrice(value){
      if(!value) this.cityRegionHeaderItem.regionHeaderList.forEach(regionItem=>{
        // 只留一条
        if(regionItem.priceDetailList.length>1) regionItem.priceDetailList.splice(1,regionItem.priceDetailList.length-1);
      })
    },
    /**
     * 改变 起运城市
     */
    changeCityList(val){
      this.$emit("changeCityValue",val);
      let labelText = val.map(v=>v.cityName).join(",");
      if(!labelText) labelText = "请选择城市";
      this.cityRegionHeaderItem.label = labelText;
    },
    /**
     * 增加 可走货物类型方案
     */
    addGoodsTypeRow(item,index){
      let tableHeadList = this.tableHeadList||[];
      let goodsTypeList = [];
      let priceList = tableHeadList.map(res=>{
        if(!(res instanceof Object)) res = {};
        return Object.assign(baseDataPriceDetailPriceItem(),{
          chargeSectionDetailId:res.chargeSectionDetailId,// 分区区间id
          sectionStartNum:res.start,// 区间开始值
          sectionEndNum:res.end,// 区间结束值
        })
      });
      let priceDetailItem = Object.assign(baseDataPriceDetailItem(),{
        goodsTypeList,
        priceList,
      })
      item.priceDetailList.push(priceDetailItem);
    },
    removeGoodsTypeRow(item,index){
      item.priceDetailList.splice(index,1);
    },
  },
}
</script>

<style scoped lang="scss">
@import "../boxItem";
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/regionNameAndSelect/cityRegionNameAndSelect3.vue